/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Regenerated by `npm run cms:sync` from /api/cms/public/overrides.
 * Each key is `${pageSlug}::${slotKey}` per the tCms helper contract.
 */

export type CmsLocale = 'zh-Hant' | 'zh-Hans' | 'en'

export interface CmsOverride {
  'zh-Hant': string
  'zh-Hans': string
  en: string
}

export const cmsOverrides: Record<string, CmsOverride> = {
}
